'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { CustomLink } from '@/app/_components/CustomLink';
import { useNavigationGroupList } from '../../_hooks/useNavigationGroupList';
export const MyNavigation = () => {
  const $ = _c(7);
  const {
    navigationGroupList
  } = useNavigationGroupList("desktop");
  const pathname = usePathname() ?? "";
  let t0;
  if ($[0] !== navigationGroupList || $[1] !== pathname) {
    let t1;
    if ($[3] !== pathname) {
      t1 = group => <li key={group.label} className="flex flex-col gap-16"><p className="font-700 text-Gray-900 typo-body2">{group.label}</p><ul className="flex flex-col gap-12">{group.items.map(item => {
            const activePathname = item.activePathname ?? item.href;
            const isActive = pathname === activePathname || pathname.startsWith(`${activePathname}/`);
            const content = <><p className={cn("font-500 text-Gray-550 typo-body3", {
                "text-Gray-900": isActive
              })}>{item.label}</p>{item.isNew ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="7.99805" cy="8" r="8" fill="#F5511D" /><path d="M10.37 5V11H9.41L6.56 6.9H6.51V11H5.44V5H6.42L9.24 9.1H9.3V5H10.37Z" fill="white" /></svg> : null}</>;
            return <li key={item.label} className="flex items-center justify-between pl-12">{item.onClick ? <button type="button" aria-current={isActive ? "page" : undefined} className="relative flex w-fit items-center gap-4" onClick={item.onClick}>{content}</button> : <CustomLink aria-current={isActive ? "page" : undefined} className="relative flex w-fit items-center gap-4" href={item.href} aria-label={`${item.label} 페이지로 이동`}>{content}</CustomLink>}</li>;
          })}</ul></li>;
      $[3] = pathname;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = navigationGroupList.map(t1);
    $[0] = navigationGroupList;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = <nav><ul className="flex flex-col gap-40">{t0}</ul></nav>;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};